import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import { Header } from './Header';

interface AppShellProps {
  children: ReactNode;
}

export const AppShell: React.FC<AppShellProps> = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { pathname } = useLocation();

  // Routes that must NOT show the owner navigation chrome:
  //  - /care/:token (#13) — the public caregiver route has its own minimal
  //    layout; the owner sidebar would bounce a logged-out caregiver to /login
  //    and confuses a logged-in owner previewing the link.
  //  - /onboarding (#17) — lock the app nav during the setup wizard so the user
  //    can't click into empty pages before their profile exists. The wizard has
  //    its own Back/Next controls, so hiding the nav doesn't trap them.
  const hideOwnerChrome =
    pathname.startsWith('/care/') || pathname === '/onboarding';

  // If not authenticated (or on a chrome-less route), render children bare.
  if (!isAuthenticated || hideOwnerChrome) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-ivory">
      {/* Desktop Sidebar - hidden on mobile */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Main Content Area */}
      <div className="flex-1 min-w-0 flex flex-col md:ml-64">
        {/* Header */}
        <Header />

        {/* Main Content — scrollbar hidden on mobile for clean feel */}
        <main className="flex-1 overflow-auto pb-16 md:pb-0 scrollbar-hide">
          {children}
        </main>

        {/* Mobile Bottom Nav - hidden on desktop */}
        <div className="md:hidden">
          <BottomNav />
        </div>
      </div>
    </div>
  );
};
